import { render, staticRenderFns } from "./center-bottom.vue?vue&type=template&id=14a94197&scoped=true"
import script from "./center-bottom.vue?vue&type=script&lang=js"
export * from "./center-bottom.vue?vue&type=script&lang=js"
import style0 from "./center-bottom.vue?vue&type=style&index=0&id=14a94197&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14a94197",
  null
  
)

export default component.exports